import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BfHeader from '../BlackFriday/BfHeader';
import Omega3Image from '../../../assets/bf-roll/omega3.webp';
import CreatineImage from '../../../assets/bf-roll/creatine.webp';
import './AddToRoutine.css';

// Generic add-on chooser (QR stickers, inserts): pick a product, then say whether
// you have an active riise subscription. Each answer gets its own path.
// TODO: set buyPath / subscriberPath once the target pages exist (null = not wired yet).
const PRODUCTS = {
  omega3: { nameKey: 'ATR_ProductOmega3', image: Omega3Image, buyPath: null, subscriberPath: null },
  kreatin: { nameKey: 'ATR_ProductKreatin', image: CreatineImage, buyPath: null, subscriberPath: null },
};
const KEY = 'ATR_';

const AddToRoutine = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Renders outside AppLayout, so the global ?lang= handler in Layout.jsx never
  // runs and i18n stays on its init value ('en'). Stickers and inserts are German:
  // default to German unless the URL asks for another supported language.
  useEffect(() => {
    const urlLang = (searchParams.get('lang') || '').toLowerCase();
    const lng = ['de', 'en', 'fr'].includes(urlLang) ? urlLang : 'de';
    if (i18n.language !== lng) i18n.changeLanguage(lng);
    localStorage.setItem('lang', lng);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [productKey, setProductKey] = useState(PRODUCTS[searchParams.get('p')] ? searchParams.get('p') : null);
  const product = productKey ? PRODUCTS[productKey] : null;
  const source = searchParams.get('src') || 'direct';

  const go = (path) => {
    if (!path) return;
    const params = new URLSearchParams(searchParams);
    params.set('utm_source', source);
    params.set('utm_campaign', `addon_${productKey}`);
    params.delete('p');
    params.delete('src');
    navigate(`${path}?${params.toString()}`);
  };

  return (
    <div className="bflg atr">
      <Helmet>
        <title>{t(`${KEY}MetaTitle`)}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <BfHeader />
      <main className="atr__main">
        <h1 dangerouslySetInnerHTML={{ __html: t(`${KEY}Title`) }} />

        <p className="atr__step">{t(`${KEY}StepProduct`)}</p>
        <div className="atr__products">
          {Object.entries(PRODUCTS).map(([key, item]) => (
            <button
              key={key}
              type="button"
              className={`atr__product${productKey === key ? ' atr__product--active' : ''}`}
              aria-pressed={productKey === key}
              onClick={() => setProductKey(key)}
            >
              <img className="atr__product-img" src={item.image} alt="" width="56" height="78" />
              <span>{t(item.nameKey)}</span>
            </button>
          ))}
        </div>

        {product && (
          <>
            <p className="atr__step">{t(`${KEY}StepSub`)}</p>
            <div className="atr__options">
              <button type="button" className="atr__option atr__option--primary" onClick={() => go(product.subscriberPath)}>
                <span className="atr__option-title">{t(`${KEY}YesTitle`)}</span>
                <span className="atr__option-text">{t(`${KEY}YesText`, { product: t(product.nameKey) })}</span>
              </button>
              <button type="button" className="atr__option" onClick={() => go(product.buyPath)}>
                <span className="atr__option-title">{t(`${KEY}NoTitle`)}</span>
                <span className="atr__option-text">{t(`${KEY}NoText`, { product: t(product.nameKey) })}</span>
              </button>
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default AddToRoutine;
